import { render, staticRenderFns } from "./ContactOpportunities.vue?vue&type=template&id=617a1041&"
import script from "./ContactOpportunities.vue?vue&type=script&lang=js&"
export * from "./ContactOpportunities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports